import { createFileRoute } from "@tanstack/react-router";
import { Assessment } from "@/lib/lazyPages";
import { SEO, assessmentFaqJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessment/")({
  head: () => {
    return seoHead({
      ...SEO.assessment,
      jsonLd: [assessmentFaqJsonLd],
    });
  },
  component: Assessment,
});
